//@ts-nocheck
function getClaims() {
  const claims = parseJwt(getToken())

  if (claims) {
    delete claims.iss
    delete claims.sub
  }

  return claims
}

export function parseJwt(c) {
  try {
    const b = c.split('.')[1]
    const a = b.replace('-', '+').replace('_', '/')
    return JSON.parse(window.atob(a))
  } catch (err) {
    console.log(err, 'parseJWT errors')
    return {}
  }
}

function getToken() {
  const container = document.getElementsByClassName('container')[0]
  const url = container ? new URL(container.children[0].src) : window.location

  return url.pathname.split('/')[2]
}

// Tracking user clicking on the “Request content inventory” button.
export function trackRequestClick() {
  window.pageData = generateBasePageData()
  window.pageDataTracker.trackEvent('ctaClick', {
    cta: {
      ids: ['bpdg:request-content-inventory'],
    },
  })
}

export function generateInitialPageData(loadTime) {
  const claims = getClaims()
  return {
    page: {
      environment: process.env.REACT_APP_ELS_ADOBE_ANALYTICS_ENV,
      productName: 'bpdg',
      language: 'en',
      type: 'RP-EX',
      name: 'content reports:inventory:request',
      businessUnit: 'els:rp:st',
      loadTime: loadTime.toString(),
      loadTimestamp: '' + new Date().getTime(),
      noTracking: '' + ('trackUser' in claims && !claims.trackUser),
    },
    visitor:
      'accessType' in claims ? claims : { accessType: 'bpdg:ANON_GUEST' },
  }
}

export function generateBasePageData() {
  const claims = getClaims()
  return {
    page: {
      environment: process.env.REACT_APP_ELS_ADOBE_ANALYTICS_ENV,
      productName: 'bpdg',
      language: 'en',
      type: 'RP-EX',
      name: 'content reports:inventory:request',
      businessUnit: 'els:rp:st',
      loadTimestamp: '' + new Date().getTime(),
      noTracking: '' + ('trackUser' in claims && !claims.trackUser),
    },
    visitor:
      'accessType' in claims ? claims : { accessType: 'bpdg:ANON_GUEST' },
  }
}

export class LoadTracker {
  constructor() {
    this.loadStart = null
    this.loadTime = null
  }

  startTracking() {
    this.loadStart = Date.now()
  }

  stopTracking() {
    this.loadTime = Date.now() - this.loadStart
  }
}
